import config from '../constants/site-config';
import { spanishToEnglishUrls, englishToSpanishUrls } from '../constants/es-en-urls-maps';

const en = config.locales[1];
const es = config.locales[0];

export const getLocalizedUrl = (locale, location) => {
  const esLocalePrefix = `/${es}`;

  const pathName =
    location.pathname[location.pathname.length - 1] === '/'
      ? location.pathname.slice(0, -1)
      : location.pathname;

  switch (locale) {
    case en: {
      const formattedPathName = decodeURI(pathName.replace(`${esLocalePrefix}/`, '/'));

      const engUrlPath = spanishToEnglishUrls.get(formattedPathName) ?? pathName;

      const isIndexEnglishPage = engUrlPath === '/es';

      const localizedEnglishPath = isIndexEnglishPage
        ? engUrlPath.replace(`${esLocalePrefix}`, '/')
        : engUrlPath.replace(`${esLocalePrefix}/`, '/');

      return engUrlPath.includes(`${esLocalePrefix}`) ? localizedEnglishPath : engUrlPath;
    }
    case es: {
      const spanishUrlPath = englishToSpanishUrls.get(pathName) ?? pathName;

      const isIndexPage = spanishUrlPath === '/es';
      const isBlogPage = spanishUrlPath.includes('/blog');

      let localizedSpanishPath = `${esLocalePrefix}${spanishUrlPath}/`;

      if (isIndexPage) {
        localizedSpanishPath = `${esLocalePrefix}/`;
      }
      if (isBlogPage) {
        localizedSpanishPath = `${esLocalePrefix}/`;
      }

      return spanishUrlPath.includes(`${esLocalePrefix}/`) ? spanishUrlPath : localizedSpanishPath;
    }
  }
};
